import { EditorModes } from 'editor/components/EditorMode';
import UpdateTextInteraction from 'editor/components/interactions/UpdateTextInteraction';
import Markup from 'editor/components/Markup';
import { Rect } from 'editor/geometry';
import { DBLClickArgs } from 'editor/systems/addSheetEvents/sheetEventHandlers';
import { getHitMarkups } from 'editor/utils/hitDetection';
import { createEditorTextarea } from 'editor/utils/text';

const updateTextEvents = {
  dblclick({
    hit,
    world,
    markupKit,
    mode,
    carnDoc,
    sheetComp,
    domOverlay,
  }: DBLClickArgs): void {
    const { MKPoint } = markupKit;

    // Everything else in the function only has to do with non-viewonly mode.
    if (mode === EditorModes.ViewOnly) {
      return;
    }

    const point = new MKPoint(hit.x, hit.y);

    // create updateTextInteraction entity, if text markup is hit.
    getHitMarkups(world, point)
      .map((entity) => entity.get(Markup))
      .filter((mc) => mc.mkMarkup?.getType() === 'FreeText')
      .filter((mc) => !mc.isRFI)
      .forEach((mc) => {
        if (mc.mkMarkup) {
          mc.hidden = true;
          const text = mc.mkMarkup.getText();
          const box = Rect.fromMKBBox(mc.mkMarkup.getBBox());

          world
            .createEntity()
            .add(carnDoc)
            .add(sheetComp)
            .add(domOverlay)
            .add(mc)
            .add(
              new UpdateTextInteraction({
                box,
                element: createEditorTextarea(text),
                elAdded: false,
                mode: 'update',
              })
            );
        }
      });
  },
};

export default updateTextEvents;
